/**
 *添加或者设置值
 * @param {Object} sessionMap 要设置的数据
 * @returns 返回当前sessionStorage
 */
const setSessionStorage = (sessionMap: object) => {
  for (let key in sessionMap) {
    sessionStorage.setItem(key, JSON.stringify(sessionMap[key]));
  }
  return sessionStorage;
};
/**
 *获取数据
 * @param {String} name 要获取的key
 * @returns 存在时，返回相应的值；不存在时，返回null
 */
const getSessionStorage = (name: string) => {
  if (sessionStorage.getItem(name))
    return sessionStorage.getItem(name)?.replace(/^["|'](.*)["|']$/g, "$1");
  return null;
};
/**
 *删除数据
 * @param {String} name 要删除的数据key
 * @returns 删除成功，返回true；删除失败，返回false
 */
const deleteSessionStorage = (name: string) => {
  if (getSessionStorage(name)) {
    sessionStorage.removeItem(name);
    return true;
  }
  return false;
};
/**
 *清除数据
 * @returns 清除成功，返回true；清除失败，返回false
 */
const clearSessionStorage = () => {
  sessionStorage.clear();
  return !sessionStorage.length;
};
export {
  setSessionStorage,
  getSessionStorage,
  deleteSessionStorage,
  clearSessionStorage,
};
